import { useEffect, useState } from "react";

import {
  CreditUtilizationData,
  calculateCreditUtilization,
} from "~/utils/creditUtilizationUtils";

export const useCreditUtilization = (clientId: string | undefined) => {
  const [creditData, setCreditData] = useState<CreditUtilizationData>({
    utilized: 0,
    available: 0,
    percentage: 0,
    salesRequestUtilized: 0,
    manualFacturasUtilized: 0,
    uncollectedChecksAmount: 0,
    portfolioChecksAmount: 0,
    insuredAmount: 0,
    totalPendingAmount: 0,
  });
  const [loading, setLoading] = useState(true);

  // Move fetchCreditUtilization outside useEffect for re-use
  const fetchCreditUtilization = async () => {
    if (!clientId) {
      setLoading(false);
      return;
    }

    setLoading(true);

    try {
      const creditUtilizationData = await calculateCreditUtilization(clientId);
      setCreditData(creditUtilizationData);
    } catch (error) {
      console.error("Error fetching credit utilization:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCreditUtilization();
  }, [clientId]);

  // Expose fetchCreditUtilization for manual refresh
  return { creditData, loading, fetchCreditUtilization };
};
